<template>
        <!-- Second section. Contains an input field used to place money on a bet -->
  <div class="a-vs-aside--input-block">

      <currency-input
        class="a-vs-c--control"
        ref="currencyValue"
        :maxValue="maxValue"
        :step="this.config.PayInStep"
        :minValue="minValue"
        :currentMoney="money"
        v-model="money"
        @onDecrementMin="onDecrementMin()"
        @onIncrementMax="onIncrementMax()"/>

      <bet-summary
        class="a-vs-b--summary"
        :numberOfTickets="picks.length"
        :totalOdds="totalOdds"
        :possibleWinning="possibleWinning" />

      <!-- Submit button -->
      <div class="soccer-bet-placing-btns">
        <button
          class="a-vs-c--button a-vs-c--button__success place-bet"
          :disabled="isDisabledPlaceBetButton()"
          @click="placeBet()">{{$t('place_bet')}}</button>
        <button
          class="a-vs-c--button a-vs-c--button__danger place-bet"
          :disabled="isTicketListEmpty()"
          @click="deleteAll(true)">{{$t('delete_all')}}</button>
      </div>

      <feed-back-modal
        v-if="isFeedBackModalVisible"
        :currentState="betPlacingModalStatus"
        :errorMessage="$t(apiErrorMessage, apiErrorParams)" />
  </div>
</template>

<script>
import api from '@/services/soccer/api.service.network.js'
import { eventBus } from '@/main.js'
import { store } from '@/store/store.js'
import NumberFormat from '@/mixins/NumberFormat'
import NetworkHelper from '@/mixins/NetworkHelper'
import VSoccerTicketHelper from '@/mixins/VSoccerTicketHelper'
import CurrencyInput from '@/components/soccer/bet-place/CurrencyInput.vue'
import FeedBackModal from '@/components/common/FeedBackModal.vue'
import BetSummary from '@/components/soccer/bet-place/BetSummary.vue'
import VSoccerHelper from '@/mixins/VSoccerHelper'
import LanguageHelper from '@/mixins/LanguageHelper'
import vuexStore from '../../../store/vuexStore'

import placeBet from '../../../assets/audio/vSoccer/place_bet.mp3'
import deleteAll from '../../../assets/audio/vSoccer/delete_all.mp3'
import betConfirmed from '../../../assets/audio/bet_confirmed.mp3'

export default {
  components: {
    'feed-back-modal': FeedBackModal,
    'currency-input': CurrencyInput,
    'bet-summary': BetSummary
  },
  mixins: [NumberFormat, VSoccerTicketHelper, VSoccerHelper, NetworkHelper, LanguageHelper],
  props: {
    config: {
      type: Object,
      required: true
    },
    errorIsShown: {
      type: Boolean,
      required: true
    },
    amount: {
      type: Number
    },
    picks: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    currentMoney: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      betPlacingModalStatus: -1,
      isBettingButtonEnabled: true,
      apiErrorMessage: '',
      apiErrorParams: null,
      isMaxValueError: false,
      isMinValueError: false,
      money: 1.00,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    onIncrementMax () {
      this.isMaxValueError = true
    },
    onDecrementMin () {
      this.isMinValueError = true
    },
    showLoadingModal () {
      this.betPlacingModalStatus = 3
    },
    showSuccessModal () {
      this.betPlacingModalStatus = 1
    },
    showErrorModal () {
      this.betPlacingModalStatus = 2
    },
    hideModal () {
      this.betPlacingModalStatus = -1
    },
    getMinMaxValue () {
      return {
        'minValue': this.formatCurrency(this.minValue),
        'maxValue': this.formatCurrency(this.maxValue)
      }
    },
    getPaymentErrorMessage () {
      if (!this.isEnoughtMoney() && !this.isTicketListEmpty()) {
        return 'no_money'
      }
      if (this.isMaxValueError) return 'max_allowed_payment'
      if (this.isMinValueError) return 'min_allowed_payment'
      return ''
    },
    checkMaxMinValueError () {
      if (this.minValue <= this.money) {
        this.isMinValueError = false
      }
      if (this.maxValue >= this.money) {
        this.isMaxValueError = false
      }
    },
    isTicketListEmpty () {
      return this.picks.length === 0
    },
    isEnoughtMoney: function () {
      return this.money <= this.amount
    },
    isDisabledPlaceBetButton: function () {
      return !this.isPlaceBetActive ||
      !this.isBettingEnabled ||
      !this.isEnoughtMoney() ||
      this.isTicketListEmpty() ||
      (this.errorIsShown && (this.money < this.minValue || this.money >= this.maxValue))
    },
    placeBet: function () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(placeBet)
        audio.play()
      }
      if (!this.isDisabledPlaceBetButton()) {
        this.isBettingButtonEnabled = false
        this.showLoadingModal()
        api.insertTicket(this.money, this.preparedMaches(this.picks)).subscribe(data => {
          this.isBettingButtonEnabled = true
          api.getBalance()
          if (data && data.ResponseCode === 0) {
            store.setBalance(data.Balance / 100)
            this.showSuccessModal()
            setTimeout(() => {
              this.hideModal()
              eventBus.onTicketInserted(data)
            }, 1000)
            this.deleteAll(false)
            if (this.hasAudioEnabled) {
              var audio = new Audio(betConfirmed)
              audio.play()
            }
          } else {
            this.apiErrorMessage = this.getMessageByError(data.ResponseCode)
            let maxAmount = this.formatCurrency(data.Amount)
            this.apiErrorParams = this.getMessageByErrorParams(data.ResponseCode, this.minValue, maxAmount)
            this.showErrorModal()
            setTimeout(() => {
              this.hideModal()
              this.betPlacingModalNotPassed = false
              this.apiErrorMessage = ''
              this.apiErrorParams = null
            }, 2000)
          }
        }, eventBus.onApiError)
      }
    },
    deleteAll: function (shouldPlaySound) {
      if (shouldPlaySound) {
        if (this.hasAudioEnabled) {
          var audio = new Audio(deleteAll)
          audio.play()
        }
      }
      this.$emit('onDeleteAll')
    },
    formatCurrency: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    }
  },
  watch: {
    config: function (val) {
      if (val && val.DefaultPayin) {
        this.money = val.DefaultPayin
      }
    },
    currentMoney: function (val) {
      this.money = val
    },
    money: function () {
      this.checkMaxMinValueError()
      this.$emit('input', this.money)
    },
    picks: function () {
      this.checkMaxMinValueError()
    },
    isPlaceBetEnabled: function () {
      if (!this.isBettingEnabled) return false
      if (!this.isBettingButtonEnabled) return false
      if (this.picks.length === 0) return false
      let deletedItems = this.picks.filter(p => p.isDeleted === true)
      if (deletedItems.length > 0) return false
      if (this.errorIsShown && (this.money <= this.minValue || this.money >= this.maxValue)) return false
      return true
    }
  },
  computed: {
    isBettingEnabled: function () {
      let result = true
      this.picks.forEach((element) => {
        result &= element.isBettingEnabled
      })
      return result
    },
    isPlaceBetActive: function () {
      return this.picks.filter(element => ((element.isDeleted))).length === 0
    },
    numberOfItems: function () {
      return this.picks.length === 0 ? 1 : this.picks.length
    },
    maxValue: function () {
      return this.getMaxValue(this.config, this.numberOfItems)
    },
    minValue: function () {
      return this.getMinValue(this.config, this.numberOfItems)
    },
    isFeedBackModalVisible: function () {
      return this.betPlacingModalStatus !== -1
    },
    possibleWinning: function () {
      if (this.money < this.minValue) {
        return 0
      }
      return this.money * this.totalOdds
    },
    totalOdds: function () {
      if (this.picks.length === 0) {
        eventBus.updateTotalOdds(0)
        return 0
      }
      let sum = 1
      this.picks.forEach(m => { sum *= (m.activeStake.Factor / 100) })
      eventBus.updateTotalOdds(sum)
      return sum
    }
  }
}
</script>
